import { Debug } from './debugLogs';

export const reproio = (...params: any[]) => {
  try {
    //@ts-ignore
    const reproio = window.reproio as any;
    if (reproio) {
      return reproio(...params);
    } else {
      Debug.error('Call repro error: not found reproio!');
    }
  } catch (error) {
    Debug.error(`Call repro error: ${error}`);
  }
};
